export enum DateTimeFormat {
  YearMonthDate = "yyyy-MM-DD",
  DateMonthYear = "DD/MM/YYYY",
  DateMonthYearPicker = "DD/MM/yyyy",
}
